import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useParamHttp } from '@/core/api/params'
import { Param, ParamPayload } from '@/core/models/param'

export type ParamCollection = {
    data: Array<Param>,
    meta?: MetaPayload,
    links?: any
}

const state: ParamCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const paramCollection: Module<ParamCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: ParamCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: ParamPayload) => {
                state.data.push(new Param(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useParamHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: ParamCollection): ParamCollection => {
            return state
        }
    }
}